module.exports = __webpack_public_path__ + "img/pr-7.b4e95b9e.png";